<template>
  <div id="map"></div>
</template>

<script>
  import mapboxgl from 'mapbox-gl';

  export default {
    name: "ServiceMap",
    data: () => ({
      map: undefined,
      home: require('@/assets/house.png'),
      userMarker: undefined,
      contactMarker: undefined,
    }),
    created() {
      mapboxgl.accessToken = process.env.VUE_APP_MAPBOX;
    },
    mounted() {
      this.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [this.contact.lng, this.contact.lat],
        zoom: 10,
      });
      this.contactMarker = new mapboxgl.Marker(this.getContactMarker());
      this.contactMarker.setLngLat([this.contact.lng, this.contact.lat]);
      this.contactMarker.addTo(this.map);
    },
    computed: {
      contact() {
        return this.$store.getters.contact;
      },
      user() {
        return this.$store.getters.user;
      }
    },
    watch: {
      user(newValue, oldValue) {
        if (!document.getElementById('user_marker')) {
          this.userMarker = new mapboxgl.Marker(this.getUserMarker(newValue))
            .setLngLat([newValue.lng, newValue.lat])
            .addTo(this.map);
        } else {
          this.userMarker.setLngLat([newValue.lng, newValue.lat]);
        }

        this.map.setCenter([newValue.lng, newValue.lat]);
        this.map.setZoom(10);
      }
    },
    methods: {
      getContactMarker() {
        const el = document.createElement('div');
        el.id = 'contact_marker';
        el.style.height = '40px';
        el.style.width = '40px';
        el.style.backgroundImage = `url(${this.home})`;
        el.style.backgroundSize = 'cover';
        return el;
      },
      getUserMarker(user) {
        const el = document.createElement('div');
        el.id = 'user_marker';
        el.style.height = '40px';
        el.style.width = '40px';
        el.style.borderRadius = '50%';
        el.style.backgroundImage = `url(${user.photoUrl ? user.photoUrl : this.contact.location.avatarUrl})`;
        el.style.backgroundSize = 'cover';
        return el;
      }
    }
  }
</script>

<style scoped>
  #map {
    width: 100%;
    height: 400px;
  }
</style>
